import UserAccountForm from './UserAccountForm'

export default UserAccountForm
